import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Checkbox, Col, message, Modal, Row, Space, Tooltip } from 'antd';
import { PRODUCT } from '../../../../constants/define/translation';
import { btnActive } from '../../../../styles';
import {
  postUpdateProductRepository,
  ProductOrders,
} from '../../../../repository/mytm/shop-product/shopProductRepository';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { UserContext } from '../../../../repository/context/userContext';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';

interface ActionsColumnProps {
  record: ProductOrders;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PRODUCT);
  const { record, onRefresh } = props;
  const userContext = useContext(UserContext);
  const [loading, setLoading] = useState(false);

  const [itemValue, setItemValue] = useState<any>();

  useEffect(() => {
    const defaultValue = record.participationLevel?.split(',').map(item => {
      if (item.length > 0) {
        return Number(item);
      }
      return null;
    });
    setItemValue(defaultValue);
  }, [record]);

  const updateProduct = async (id: string, payload: any) => {
    setLoading(true);
    return postUpdateProductRepository(id, payload)
      .then(() => {
        onRefresh();
        message.success(t('message.updateProductSuccess'));
      })
      .catch(e => {
        setLoading(false);
        message.error(e?.errorMessage || t('message.updateProductError'));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onUpdateParticipation = (updateValue: { productId: string; participationLevel: any; country: any }) => {
    const payload = {
      productId: updateValue.productId,
      participationLevel: updateValue.participationLevel,
      country: updateValue?.country,
    };
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.update')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateProduct(record.id, payload);
            })
            .catch((e: any) => {
              setLoading(false);
              onRefresh();
              message.error(e?.errorMessage || t('message.updateProductError'));
            });
        }
      },
    });
  };

  const handleOnEdit = async (value: any) => {
    try {
      const participationLevel = value.length > 0 ? value.join(',').toString() : '';
      onUpdateParticipation({ productId: record.product_id, participationLevel, country: record?.country });
    } catch (error) {
      message.error(t('message.updateProductError'));
    }
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Checkbox.Group value={itemValue} onChange={handleOnEdit} disabled={loading} defaultValue={itemValue}>
          <Row>
            <Col span={12}>
              <Checkbox value={0} checked>
                <Tooltip
                  title={itemValue?.length === 1 && itemValue[0] === 0 ? '' : t('table.tooltip.membership.free')}
                >
                  {t('form.setting.participationLevelZero')}
                </Tooltip>
              </Checkbox>
              <Checkbox disabled value={1} style={{ margin: 0 }}>
                <Tooltip
                  title={itemValue?.length === 1 && itemValue[0] === 1 ? '' : t('table.tooltip.membership.champion')}
                >
                  {t('form.setting.participationLevelOne')}
                </Tooltip>
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
